import { I18n } from '@calendly/i18n'

import { Spotlight } from 'components/core/spotlight'
import { MI_MEETINGS_TOUR } from 'features/meeting_intelligence/constants'
import { useURLParams } from 'features/meeting_intelligence/hooks'
import { handleDefaults } from 'features/meeting_intelligence/utils'
import { useTrack, useTrackOnce } from 'hooks/analytics_events/useTrack'

const STEP_TWO_SHOWN = {
  name: 'Tooltip Shown',
  properties: {
    tooltip_name: 'find_meeting_recaps',
    tooltip_flow: 'ai_notetaker_tour',
    tooltip_location: 'meetings_page_scroll',
  }
}

const STEP_TWO_CLICKED = {
  name: 'Tooltip Clicked',
  properties: {
    tooltip_name: 'find_meetings_recap',
    tooltip_flow: 'ai_notetaker_tour',
    tooltip_location: 'meetings_page_scroll',
    action: 'tooltip_clicked'
  }
}

const STEP_TWO_DISMISSED = {
  name: 'Tooltip Clicked',
  properties: {
    tooltip_name: 'find_meetings_recap',
    tooltip_flow: 'ai_notetaker_tour',
    tooltip_location: 'meetings_page_scroll',
    action: 'dismissed'
  }
}

export const StepTwo = ({ isVisible = true }) => {
  const track = useTrack()
  const { findParam, replaceParam, removeParam } = useURLParams()
  const showTooltip = findParam(MI_MEETINGS_TOUR.STEP_TWO) && isVisible

  useTrackOnce(showTooltip, STEP_TWO_SHOWN)

  const handleContinue = (e) => {
    handleDefaults(e)
    track(STEP_TWO_CLICKED)
    replaceParam(MI_MEETINGS_TOUR.STEP_THREE, MI_MEETINGS_TOUR.STEP_TWO)
  }

  const handleDismiss = (e) => {
    handleDefaults(e)
    track(STEP_TWO_DISMISSED)
    removeParam(MI_MEETINGS_TOUR.STEP_TWO)
  }

  if (!showTooltip) return null

  return (
    <Spotlight
      headingText={I18n.t('publisher.meeting_intelligence.tour.step_two.title')}
      bodyText={I18n.t('publisher.meeting_intelligence.tour.step_two.body_text')}
      primaryButtonLabel={I18n.t('publisher.meeting_intelligence.tour.next')}
      footerText={I18n.t('publisher.meeting_intelligence.tour.step_two.progress')}
      onClickPrimary={handleContinue}
      placement="bottom"
      offset={20}
      onClose={handleDismiss}
      outsideClickDetectionEnabled={false}
    />
  )
}
